import React, { Fragment } from "react";
import Privacy from "../components/Privacy";

const Policy = () => {
  return (
    <Fragment>
      <h1>정책</h1>
      <hr />
      <Privacy />
    </Fragment>
  );
};

export default Policy;
